// Copyright (c) 2026 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { ItemDataUpload } from '@/items/components/item-data-upload/item-data-upload';
import { Dialog, DialogContent, DialogTitle } from '@mui/material';

interface Props {
  isOpen: boolean;
  onClose: () => void;
}

export function ItemDataImportDialog(props: Props) {
  return (
    <Dialog fullWidth maxWidth="lg" open={props.isOpen} onClose={props.onClose}>
      <DialogTitle>Bulk upload items</DialogTitle>
      <DialogContent dividers>
        <ItemDataUpload onClose={props.onClose} />
      </DialogContent>
    </Dialog>
  );
}
